export default __webpack_public_path__ + "static/media/q23_03.cf12c711.png";